export default __webpack_public_path__ + "assets/images/6a96387d24c3fccff44f719d0b25cdac.png";